import { c as _c } from "react/compiler-runtime";
import { Box, chakra, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { FAST_AGREEMENT_PREAMBLE, FAST_SECURITY_TYPE, FAST_VERSION, fastAgreementArticles, fastAgreementCountLabel, fastAgreementIntroGrantSentence, fastAgreementPriceLabel, fastAgreementPriceSentence, fastAgreementSchedule, fastAgreementServicesBlank, fastAgreementVestingSentence } from '@src/components/sco/Advisors/data/fastAgreement';
import { Fill } from '@src/components/sco/Advisors/shared/Fill';
import type { ReactNode } from 'react';
export type LegalDocumentFields = {
  startDateLabel?: string;
  companyName?: string;
  advisorName?: string;
  expertiseLabel?: string;
  engagementTierLabel?: string;
  hoursPerMonthLabel?: string;
  companyStageLabel?: string;
  governingLawLabel?: string;
  securityTypeLabel?: string;
  equityPercentLabel?: string;
  vestingMonthsLabel?: string;
  cliffMonthsLabel?: string;
  founderSignLabel?: string;
  advisorSignLabel?: string;
  founderSigned?: boolean;
  advisorSigned?: boolean;
  additionalTerms?: string;
};
const blank = (value?: string) => value?.trim() || '—';
const TermsRow = t0 => {
  const $ = _c(9);
  const {
    label,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: 1,
      sm: 2
    };
    t2 = {
      base: 0,
      sm: 3
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <Text color="black/70" fontSize="xs" fontWeight="semibold" textTransform="uppercase">{label}</Text>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <Text fontSize="sm">{children}</Text>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <SimpleGrid columns={t1} gap={t2}>{t3}{t4}</SimpleGrid>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
const Clause = t0 => {
  const $ = _c(7);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Text fontWeight="bold">{title}</Text>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <Text>{children}</Text>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Box>{t1}{t2}</Box>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const LegalDocument = t0 => {
  const $ = _c(142);
  const {
    variant,
    fields: t1
  } = t0;
  let T0;
  let T1;
  let schedule;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t27;
  let t28;
  let t29;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t1 || $[1] !== variant) {
    const fields = t1 === undefined ? {} : t1;
    const security = blank(fields.securityTypeLabel) === "\u2014" ? FAST_SECURITY_TYPE : fields.securityTypeLabel;
    const governingLaw = blank(fields.governingLawLabel) === "\u2014" ? "the jurisdiction of the Company's incorporation" : fields.governingLawLabel;
    const articles = fastAgreementArticles(security);
    schedule = fastAgreementSchedule();
    const servicesBlank = fastAgreementServicesBlank({
      tier: fields.engagementTierLabel,
      stage: fields.companyStageLabel,
      expertise: fields.expertiseLabel
    });
    T1 = Box;
    t19 = "orange.50";
    t20 = "lg";
    t21 = "md";
    t22 = "black";
    t23 = "longform";
    t24 = variant === "sign" ? "340px" : undefined;
    t25 = variant === "sign" ? "auto" : undefined;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = {
        base: 5,
        md: 8
      };
      t27 = <Heading letterSpacing="wider" size="lg" textAlign="center">FOUNDER ADVISOR STANDARD TEMPLATE</Heading>;
      t28 = <Text fontFamily="body" fontSize="xs" fontWeight="medium" marginBottom={6} marginTop={1} textAlign="center">FAST · Version {FAST_VERSION}</Text>;
      $[33] = t26;
      $[34] = t27;
      $[35] = t28;
    } else {
      t26 = $[33];
      t27 = $[34];
      t28 = $[35];
    }
    let t30;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t30 = <Text fontFamily="body" fontSize="xs" fontWeight="bold" letterSpacing="wider">FAST TERMS</Text>;
      $[36] = t30;
    } else {
      t30 = $[36];
    }
    let t31;
    if ($[37] !== security) {
      t31 = fastAgreementCountLabel(security);
      $[37] = security;
      $[38] = t31;
    } else {
      t31 = $[38];
    }
    let t32;
    if ($[39] !== security) {
      t32 = fastAgreementIntroGrantSentence(security);
      $[39] = security;
      $[40] = t32;
    } else {
      t32 = $[40];
    }
    let t33;
    if ($[41] !== t31 || $[42] !== t32) {
      t33 = <TermsRow label={t31}>{t32}</TermsRow>;
      $[41] = t31;
      $[42] = t32;
      $[43] = t33;
    } else {
      t33 = $[43];
    }
    let t34;
    if ($[44] !== security) {
      t34 = fastAgreementPriceLabel(security);
      $[44] = security;
      $[45] = t34;
    } else {
      t34 = $[45];
    }
    let t35;
    if ($[46] !== security) {
      t35 = fastAgreementPriceSentence(security);
      $[46] = security;
      $[47] = t35;
    } else {
      t35 = $[47];
    }
    let t36;
    if ($[48] !== t34 || $[49] !== t35) {
      t36 = <TermsRow label={t34}>{t35}</TermsRow>;
      $[48] = t34;
      $[49] = t35;
      $[50] = t36;
    } else {
      t36 = $[50];
    }
    t29 = <VStack align="stretch" borderColor="black/15" borderWidth="1px" fontSize="sm" gap={2} marginBottom={6} padding={4}>{t30}<TermsRow label="Company Name"><Fill>{blank(fields.companyName)}</Fill></TermsRow><TermsRow label="Effective Date"><Fill>{blank(fields.startDateLabel)}</Fill></TermsRow><TermsRow label="Governing Law"><Fill>{governingLaw}</Fill></TermsRow><TermsRow label="Services"><Fill>{servicesBlank}</Fill></TermsRow><TermsRow label="Advisor Equity Compensation (as a %)"><Fill>{blank(fields.equityPercentLabel)}</Fill></TermsRow><TermsRow label="Type of Security"><Fill>{security}</Fill></TermsRow>{t33}{t36}<TermsRow label="Vesting">{fastAgreementVestingSentence(fields.vestingMonthsLabel, fields.cliffMonthsLabel)}</TermsRow></VStack>;
    T0 = VStack;
    t2 = "stretch";
    t3 = "sm";
    t4 = 4;
    t5 = "tall";
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Text>{FAST_AGREEMENT_PREAMBLE}</Text>;
      t7 = <Text fontWeight="bold">The parties agree as follows:</Text>;
      $[51] = t6;
      $[52] = t7;
    } else {
      t6 = $[51];
      t7 = $[52];
    }
    t8 = articles.map(_temp);
    if ($[53] !== fields.additionalTerms) {
      t9 = fields.additionalTerms?.trim() ? <Box><Text fontWeight="bold">Additional terms.</Text><Text whiteSpace="pre-wrap">{fields.additionalTerms.trim()}</Text></Box> : null;
      $[53] = fields.additionalTerms;
      $[54] = t9;
    } else {
      t9 = $[54];
    }
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Text fontWeight="bold" marginTop={4}>Signature Page to Founder Advisor Standard Template</Text>;
      $[55] = t10;
    } else {
      t10 = $[55];
    }
    let t37;
    let t38;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t37 = <Text fontWeight="bold">Company</Text>;
      t38 = <Box borderBottom="2px solid" height={6} opacity={0.5} />;
      $[56] = t37;
      $[57] = t38;
    } else {
      t37 = $[56];
      t38 = $[57];
    }
    let t39;
    if ($[58] !== fields.founderSignLabel) {
      t39 = blank(fields.founderSignLabel);
      $[58] = fields.founderSignLabel;
      $[59] = t39;
    } else {
      t39 = $[59];
    }
    const t40 = fields.founderSigned ? "green.700" : "orange.700";
    const t41 = fields.founderSigned ? "signed" : "awaiting";
    let t42;
    if ($[60] !== t40 || $[61] !== t41) {
      t42 = <chakra.span as="span" color={t40}>{t41}</chakra.span>;
      $[60] = t40;
      $[61] = t41;
      $[62] = t42;
    } else {
      t42 = $[62];
    }
    let t43;
    if ($[63] !== t39 || $[64] !== t42) {
      t43 = <Text fontSize="xs" fontWeight="bold">Signature · {t39} ·{" "}{t42}</Text>;
      $[63] = t39;
      $[64] = t42;
      $[65] = t43;
    } else {
      t43 = $[65];
    }
    let t44;
    if ($[66] !== fields.founderSignLabel) {
      t44 = blank(fields.founderSignLabel);
      $[66] = fields.founderSignLabel;
      $[67] = t44;
    } else {
      t44 = $[67];
    }
    let t45;
    if ($[68] !== t44) {
      t45 = <Text>Name: {t44}</Text>;
      $[68] = t44;
      $[69] = t45;
    } else {
      t45 = $[69];
    }
    let t46;
    let t47;
    if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
      t46 = <Text>Title:</Text>;
      t47 = <Text>Address:</Text>;
      $[70] = t46;
      $[71] = t47;
    } else {
      t46 = $[70];
      t47 = $[71];
    }
    let t48;
    if ($[72] !== t43 || $[73] !== t45) {
      t48 = <VStack align="stretch" gap={2}>{t37}{t38}{t43}{t45}{t46}{t47}</VStack>;
      $[72] = t43;
      $[73] = t45;
      $[74] = t48;
    } else {
      t48 = $[74];
    }
    let t49;
    let t50;
    if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
      t49 = <Text fontWeight="bold">Advisor</Text>;
      t50 = <Box borderBottom="2px solid" height={6} opacity={0.5} />;
      $[75] = t49;
      $[76] = t50;
    } else {
      t49 = $[75];
      t50 = $[76];
    }
    const t51 = fields.advisorSignLabel || fields.advisorName;
    let t52;
    if ($[77] !== t51) {
      t52 = blank(t51);
      $[77] = t51;
      $[78] = t52;
    } else {
      t52 = $[78];
    }
    const t53 = fields.advisorSigned ? "green.700" : "orange.700";
    const t54 = fields.advisorSigned ? "signed" : "awaiting";
    let t55;
    if ($[79] !== t53 || $[80] !== t54) {
      t55 = <chakra.span as="span" color={t53}>{t54}</chakra.span>;
      $[79] = t53;
      $[80] = t54;
      $[81] = t55;
    } else {
      t55 = $[81];
    }
    let t56;
    if ($[82] !== t52 || $[83] !== t55) {
      t56 = <Text fontSize="xs" fontWeight="bold">Signature · {t52} ·{" "}{t55}</Text>;
      $[82] = t52;
      $[83] = t55;
      $[84] = t56;
    } else {
      t56 = $[84];
    }
    const t57 = fields.advisorSignLabel || fields.advisorName;
    let t58;
    if ($[85] !== t57) {
      t58 = blank(t57);
      $[85] = t57;
      $[86] = t58;
    } else {
      t58 = $[86];
    }
    let t59;
    if ($[87] !== t58) {
      t59 = <Text>Name: {t58}</Text>;
      $[87] = t58;
      $[88] = t59;
    } else {
      t59 = $[88];
    }
    let t60;
    let t61;
    if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
      t60 = <Text>Title:</Text>;
      t61 = <Text>Address:</Text>;
      $[89] = t60;
      $[90] = t61;
    } else {
      t60 = $[89];
      t61 = $[90];
    }
    let t62;
    if ($[91] !== t56 || $[92] !== t59) {
      t62 = <VStack align="stretch" gap={2}>{t49}{t50}{t56}{t59}{t60}{t61}</VStack>;
      $[91] = t56;
      $[92] = t59;
      $[93] = t62;
    } else {
      t62 = $[93];
    }
    if ($[94] !== t48 || $[95] !== t62) {
      t11 = <SimpleGrid columns={2} gap={6}>{t48}{t62}</SimpleGrid>;
      $[94] = t48;
      $[95] = t62;
      $[96] = t11;
    } else {
      t11 = $[96];
    }
    let t63;
    if ($[97] !== fields.startDateLabel) {
      t63 = blank(fields.startDateLabel);
      $[97] = fields.startDateLabel;
      $[98] = t63;
    } else {
      t63 = $[98];
    }
    let t64;
    if ($[99] !== fields.startDateLabel) {
      t64 = blank(fields.startDateLabel);
      $[99] = fields.startDateLabel;
      $[100] = t64;
    } else {
      t64 = $[100];
    }
    if ($[101] !== t63 || $[102] !== t64) {
      t12 = <Text>Date: {t63} Date: {t64}</Text>;
      $[101] = t63;
      $[102] = t64;
      $[103] = t12;
    } else {
      t12 = $[103];
    }
    if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Text fontWeight="bold" marginTop={4}>Schedule A: Services Based on Performance Level</Text>;
      $[104] = t13;
    } else {
      t13 = $[104];
    }
    t14 = <Text>{schedule.intro}</Text>;
    t15 = schedule.levels.map(_temp5);
    if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <Text fontWeight="bold" marginTop={4}>Schedule B: Company Stage</Text>;
      $[105] = t16;
    } else {
      t16 = $[105];
    }
    t17 = <Text>{schedule.stageIntro}</Text>;
    t18 = schedule.stages.map(_temp7);
    $[0] = t1;
    $[1] = variant;
    $[2] = T0;
    $[3] = T1;
    $[4] = schedule;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
    $[14] = t19;
    $[15] = t2;
    $[16] = t20;
    $[17] = t21;
    $[18] = t22;
    $[19] = t23;
    $[20] = t24;
    $[21] = t25;
    $[22] = t26;
    $[23] = t27;
    $[24] = t28;
    $[25] = t29;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    T0 = $[2];
    T1 = $[3];
    schedule = $[4];
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t17 = $[12];
    t18 = $[13];
    t19 = $[14];
    t2 = $[15];
    t20 = $[16];
    t21 = $[17];
    t22 = $[18];
    t23 = $[19];
    t24 = $[20];
    t25 = $[21];
    t26 = $[22];
    t27 = $[23];
    t28 = $[24];
    t29 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
  }
  let t30;
  if ($[106] !== schedule.benchmarksNote) {
    t30 = <Text>{schedule.benchmarksNote}</Text>;
    $[106] = schedule.benchmarksNote;
    $[107] = t30;
  } else {
    t30 = $[107];
  }
  let t31;
  if ($[108] !== T0 || $[109] !== t10 || $[110] !== t11 || $[111] !== t12 || $[112] !== t13 || $[113] !== t14 || $[114] !== t15 || $[115] !== t16 || $[116] !== t17 || $[117] !== t18 || $[118] !== t2 || $[119] !== t3 || $[120] !== t30 || $[121] !== t4 || $[122] !== t5 || $[123] !== t6 || $[124] !== t7 || $[125] !== t8 || $[126] !== t9) {
    t31 = <T0 align={t2} fontSize={t3} gap={t4} lineHeight={t5}>{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t30}</T0>;
    $[108] = T0;
    $[109] = t10;
    $[110] = t11;
    $[111] = t12;
    $[112] = t13;
    $[113] = t14;
    $[114] = t15;
    $[115] = t16;
    $[116] = t17;
    $[117] = t18;
    $[118] = t2;
    $[119] = t3;
    $[120] = t30;
    $[121] = t4;
    $[122] = t5;
    $[123] = t6;
    $[124] = t7;
    $[125] = t8;
    $[126] = t9;
    $[127] = t31;
  } else {
    t31 = $[127];
  }
  let t32;
  if ($[128] !== T1 || $[129] !== t19 || $[130] !== t20 || $[131] !== t21 || $[132] !== t22 || $[133] !== t23 || $[134] !== t24 || $[135] !== t25 || $[136] !== t26 || $[137] !== t27 || $[138] !== t28 || $[139] !== t29 || $[140] !== t31) {
    t32 = <T1 bgColor={t19} borderRadius={t20} boxShadow={t21} color={t22} fontFamily={t23} maxHeight={t24} overflowY={t25} padding={t26}>{t27}{t28}{t29}{t31}</T1>;
    $[128] = T1;
    $[129] = t19;
    $[130] = t20;
    $[131] = t21;
    $[132] = t22;
    $[133] = t23;
    $[134] = t24;
    $[135] = t25;
    $[136] = t26;
    $[137] = t27;
    $[138] = t28;
    $[139] = t29;
    $[140] = t31;
    $[141] = t32;
  } else {
    t32 = $[141];
  }
  return t32;
};
function _temp(article) {
  return <Box key={article.number}><Clause title={`${article.number}. ${article.title}.`}>{article.body}</Clause>{article.children?.map(child => <Box key={child.number} marginTop={3} paddingLeft={4}><Clause title={`${article.number}.${child.number}. ${child.title}.`}>{child.body}</Clause></Box>)}</Box>;
}
function _temp2(line) {
  return <Text key={line}>{line}</Text>;
}
function _temp3(line_0) {
  return <Text key={line_0}>{line_0}</Text>;
}
function _temp4(line_1) {
  return <Text key={line_1}>{line_1}</Text>;
}
function _temp5(level) {
  return <Box key={level.title}><Text fontWeight="bold">{level.title}</Text><Text fontWeight="semibold">Monthly Commitment</Text>{level.commitment.map(_temp2)}<Text fontWeight="semibold">Services</Text>{level.services.map(_temp3)}<Text fontWeight="semibold">Compensation</Text>{level.compensation.map(_temp4)}</Box>;
}
function _temp6(line_2) {
  return <Text key={line_2}>{line_2}</Text>;
}
function _temp7(stage) {
  return <Box key={stage.title}><Text fontWeight="bold">{stage.title}</Text>{stage.characteristics.map(_temp6)}</Box>;
}